import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import Accordion from '../Accordion';
import SelectAnswer from '../SelectAnswer';
import SelectDataset from '../SelectDataset';

const DatasetSelectTrend = props => {

    let chart;
    if ( props.selectedIndicator != undefined ){
        chart = props.chartType.find((chart) => chart.type == props.selectedIndicator)
    }

    const [selectedSource, setSelectedSource] = useState(props.selectedIndicator != undefined ? props.selectedIndicator :  props.chartType[0].type);
    const [selectedChartType, setSelectedChartType] = useState(chart != undefined ? chart : props.chartType[0] );
    const [isDatasetFilterDisabled, setIsDatasetFilterDisabled] = useState(false);
    const [firstDataset, setFirstDataset] = useState(undefined);
    const [secondDataset, setSecondDataset] = useState(undefined);
    const [filtersLabel, setFiltersLabel] = useState({
        dataset1Label: '',
        dataset2Label: '',
        answerLabel: ''
    });
    const [dataset1DefaultLabel, setDataset1DefaultLabel] = useState(undefined);
    const [sourceDefault, setSourceDefault] = useState({
        label: chart ? props.literals[`L${chart.datasetLiteral}`] : props.literals[`L${props.chartType[0].datasetLiteral}`],
        value: chart ? chart.type : props.chartType[0].type
    })

    useEffect(() => {
        let chart = props.chartType.find( (chart) => chart.type == props.selectedIndicator );
        if(!chart)
        {
            chart = props.chartType[0];
        }
        setSourceDefault({
            label: props.literals[`L${chart.datasetLiteral}`],
            value: chart.type
        });
        setSelectedSource( chart.type );
        setIsDatasetFilterDisabled(props.selectedIndicator != 'flash' ? false : true );
        setDataset1DefaultLabel('');
        setSelectedChartType(chart);
        setFiltersLabel( { ...filtersLabel, dataset2Label: '' } );
    }, [props.chartType]);

    useEffect(() => {
        if(!props.showAnswerSelect && secondDataset){
            setSecondDataset(undefined);
            setFiltersLabel( { ...filtersLabel, dataset2Label: '' } );
        }
    }, [props.showAnswerSelect])

    const onChangeSelect = (e) => {
        let chart = props.chartType.find((chart) => chart.type == e.value)
        setSelectedSource(chart.type);
        setSelectedChartType(chart);
        setIsDatasetFilterDisabled(e.value != 'flash' ? false : true);
        setDataset1DefaultLabel(undefined);
        setSourceDefault({
            label: e.label,
            value: e.value
        })

        props.callbackSelectedSurvey(chart.type);
    }

    const handleDefaultDataset = (dataset, selectedIndicator, label, isDisabled) => {
        setFiltersLabel( { ...filtersLabel, dataset1Label: label } );

        if (props.handleDefaultDataset)
        {
            props.handleDefaultDataset(dataset, selectedIndicator, label);
        }
    }

    const handleDatasetChange1 = (dataset, indicator, label, isDisabled) => {
        setFirstDataset(dataset);
        setFiltersLabel( { ...filtersLabel, dataset1Label: label != null ? label : dataset1DefaultLabel })
        
        if (dataset1DefaultLabel == undefined)
        {
            // The first time the SelectDataset is loaded, the selected value will be the default one
            setDataset1DefaultLabel(label);
        }

        props.handleDatasetChange1(dataset, null, isDisabled);
    }

    const handleDatasetChange2 = (dataset,indicator, label) => {
        if( filtersLabel.dataset1Label != label )
        {
            setSecondDataset(dataset);
            setFiltersLabel( { ...filtersLabel, dataset2Label: (', '+label) } );
        }
        
        props.handleDatasetChange2(dataset);
    }

    const handleAnswerChange = (answer, label) => {
        setFiltersLabel( { ...filtersLabel, answerLabel: (', '+label) } )
        
        props.handleAnswerChange(answer);
    }

    const resetFilter = (e) => {
        e.preventDefault();
        handleDatasetChange1(null, selectedChartType.chartIndicator, null);
    }

    let sourceSelect;
    let selectAnswerDiv;
    let secondDatasetSelect;
    let resetButton;

    let datasetLabel;
    
    //Select for answers to filter the trend
    if( props.showAnswerSelect )
    {
        selectAnswerDiv = props.fullCountryReport != true ? (
            <li className='col-12 col-md-6 col-lg-3'>
                <label>{ props.literals.L20243 }</label>
                <SelectAnswer
                    chart={ selectedChartType.chart }
                    indicator={ selectedChartType.chartIndicator }
                    handleAnswerChange={ handleAnswerChange }
                />
            </li>
        ) : ('')

        secondDatasetSelect = <li className='col-12 col-md-6 col-lg-3'>
            <label>{ props.literals.L20610 }</label>
            <SelectDataset 
                chart={ selectedChartType.chart }
                indicator={ selectedChartType.chartIndicator }
                handleDatasetChange={ handleDatasetChange2 }
                handleDefaultDataset={ handleDefaultDataset }
                defaultValue={ false }
                datasetSelected={ firstDataset }
                esener={  selectedSource == 'esener' }
                isTrend={ props.showAnswerSelect }
                yearOnly={ props.yearOnly ? props.yearOnly : false }
                split= { props.chartSplit }
            />
        </li>
        
    }

    if(props.showSourceSelect == true && !props.showAnswerSelect)
    {
        let selectOptions = props.chartType;
        sourceSelect = (
            <li className='col-12 col-md-6 col-lg-3'>
                <div className="source--dataset--block">
                    <label>{props.literals.L20315}</label>
                    <Select
                        onChange={(e) => onChangeSelect(e)}
                        value={ sourceDefault }
                        className="select-component"
                        options={ selectOptions.map(chart=>( { label: props.literals[`L${chart.datasetLiteral}`], value: chart.type } ) ) }
                        isDisabled={ props.chartType.length <= 1 }
                    />
                </div>
            </li>
        )
    }

    if(props.showButtons == true)
    {
        resetButton = (
            <li className='dataset-accordion-btn-li'>
                <div className='dataset-filter-buttons'>
                    <button className='btn-default btn-main-color' onClick={(e) => this.resetFilter(e)}>{ props.literals.L20628 }</button>
                </div>
            </li>
        )
    }

    if (props.yearOnly == true)
    {
        datasetLabel = props.literals[`L${selectedChartType.datasetLiteral}`] + ", " + filtersLabel.dataset1Label;
    }
    else
    {
        datasetLabel = filtersLabel.dataset1Label;
    }

    return(
        <div className='container dataset--filter--block'>
            <Accordion>
                <div className="accordion-title-with-labels">
                    <div className='selected--dataset--info'>
                        <label>
                            { datasetLabel } 
                            { props.showAnswerSelect && (filtersLabel.dataset2Label) }
                            { props.showAnswerSelect && (filtersLabel.answerLabel) }
                        </label>
                    </div> 
                    <h3 className="accordion-title-text">{ props.showAnswerSelect == false ? props.literals.L20555 : props.literals.L20521 }</h3>
                </div>
                <div className="accordion-content ">
                    <ul className='select--dataset--list'>
                        {/* Source filter */}
                        { sourceSelect }
                        {/* First dataset filter */}
                        <li className='col-12 col-md-6 col-lg-3'>
                            <label>{props.literals.L20267}</label>
                            <SelectDataset 
                                literals = { props.literals }
                                chart={ selectedChartType.chart }
                                indicator={ selectedChartType.chartIndicator }
                                handleDatasetChange={ handleDatasetChange1 }
                                handleDefaultDataset={ handleDefaultDataset }
                                isDisabled={ isDatasetFilterDisabled }
                                yearOnly={ props.yearOnly ? props.yearOnly : false }
                                esener={ selectedSource == 'esener' }
                                datasetSelected={ secondDataset }
                                isTrend={ props.showAnswerSelect }
                                split= { props.chartSplit }
                            />
                        </li>
                        {/* Second dataset filter */}
                        {secondDatasetSelect}
                        {/* Answer filter */}
                        {selectAnswerDiv}
                        {/* Reset Filters button */}
                        {resetButton}
                    </ul>
                </div> 
            </Accordion>                
        </div>
    )
}

export default DatasetSelectTrend;